<template>
  <el-header style="width: 100%;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
    <el-row>
      <el-col :span="1" style="height: 100%;">
        <hamburger :is-active="$store.state.side" class="hamburger-container" @toggleClick="toggleSideBar"/>
      </el-col>
      <el-col :span="20">
        <el-breadcrumb separator="/" style="line-height: 60px;float: left;">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item v-for="item in breadList" v-bind:key="item">
            {{item}}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="2">
        <el-dropdown style="float: right; height: 60px;line-height: 60px">
      <span class="el-dropdown-link">
        {{info.username}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
          <el-dropdown-menu slot="dropdown">
<!--            <el-dropdown-item>资料设置</el-dropdown-item>-->
            <el-dropdown-item divided @click.native="login_out">登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
import hamburger from './hamburger'

export default {
  name: 'Header',
  data () {
    return {
      breadList: '',
      info: ''
    }
  },
  components: {
    hamburger
  },
  created () {
    // this.breadcrumb = this.$route.meta.title
    this.info = JSON.parse(localStorage.getItem('vegetarian_info'))
    this.getterRouteInfo()
  },
  methods: {
    toggleSideBar () {
      if (this.$store.state.side) {
        this.$store.commit('sideDis')
      } else {
        this.$store.commit('sideEna')
      }
    },
    getterRouteInfo () {
      this.breadList = []
      for (const routeInfo of this.$route.matched) {
        if (typeof routeInfo.name === 'string' && routeInfo.name !== 'home') {
          this.breadList.push(routeInfo.meta.title)
        }
      }
      this.info = JSON.parse(localStorage.getItem('vegetarian_info'))
    },
    // login_out () {
    //   this.$http.post('Sign_out', this.loginFrom).then(res => {
    //     if (res.status === 'success') {
    //       this.$message.success(res.msg)
    //       localStorage.removeItem('vegetarian_token')
    //       this.$router.push({
    //         path: '/login'
    //       })
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //   })
    // }
    login_out () {
      this.$message.success('登出成功')
      localStorage.removeItem('vegetarian_token')
      this.$router.push({
        path: '/login'
      })
    }
  },
  watch: {
    $route () {
      this.getterRouteInfo()
    }
  }
}
</script>

<style scoped>
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color: transparent;
  }
  :hover {
    background: rgba(0, 0, 0, .025)
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Header.vue